import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { tokens } from './tokens';
import { semanticTokens } from './semantic-tokens';

const config = defineConfig({
  theme: {
    tokens,
    semanticTokens,
    textStyles: {
      'display-sm': { value: { fontSize: '30px', fontWeight: '600', lineHeight: '38px' } },
      xl: { value: { fontSize: '20px', fontWeight: '600', lineHeight: '30px' } },
      lg: { value: { fontSize: '18px', fontWeight: '500', lineHeight: '28px' } },
      md: { value: { fontSize: '16px', fontWeight: '400', lineHeight: '24px' } },
      sm: { value: { fontSize: '14px', fontWeight: '400', lineHeight: '20px' } },
      xs: { value: { fontSize: '12px', fontWeight: '500', lineHeight: '18px' } },
      'mono-lg': {
        value: {
          fontFamily: 'fonts.mono',
          fontVariantNumeric: 'tabular-nums',
          fontSize: '20px',
          fontWeight: '500',
          lineHeight: '30px',
        },
      },
      'mono-md': {
        value: {
          fontFamily: 'fonts.mono',
          fontVariantNumeric: 'tabular-nums',
          fontSize: '16px',
          fontWeight: '400',
          lineHeight: '24px',
        },
      },
      'mono-sm': {
        value: {
          fontFamily: 'fonts.mono',
          fontVariantNumeric: 'tabular-nums',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '20px',
        },
      },
    },
  },
});

export const system = createSystem(defaultConfig, config);
